import { render, staticRenderFns } from "./ReferralSetting.vue?vue&type=template&id=3afd7d89&scoped=true"
import script from "./ReferralSetting.vue?vue&type=script&lang=js"
export * from "./ReferralSetting.vue?vue&type=script&lang=js"
import style0 from "./ReferralSetting.vue?vue&type=style&index=0&id=3afd7d89&prod&lang=scss&scoped=true"
import style1 from "./ReferralSetting.vue?vue&type=style&index=1&id=3afd7d89&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afd7d89",
  null
  
)

export default component.exports